import { setIsPending } from '@gef-ui/redux-common/actions/appContext';
import { getRefreshToken, isPending } from '@gef-ui/redux-common/selectors/appContext';
import sleep from "@gef-ui/utils/sleep";
import mergeRight from "ramda/es/mergeRight";
import { withLogout } from '../../access/facade';
import { setAccessToken, setRefreshToken } from '../actions';
import logout from '../logout';
import obtainOAuthAccessAndRefreshToken from '../obtainOAuthAccessAndRefreshToken';
import postOauthFormEncoded from '../postOAuthFormEncodedFacade';
import { getOauthBodyWithRefreshTokenGrantType } from '../selectors';
export default ((body, beforeLogout)=>async (dispatch, getState)=>{
        const state = getState();
        if (isPending(state)) {
            while(isPending(getState())){
                await sleep(500);
            }
            return Promise.resolve();
        }
        dispatch(setIsPending(true));
        const refreshToken = getRefreshToken(state);
        if (!refreshToken) {
            return dispatch(obtainOAuthAccessAndRefreshToken(body, beforeLogout));
        }
        return dispatch(withLogout(postOauthFormEncoded, logout)({
            endpoint: ({ urls })=>`${urls.token}`,
            body: mergeRight(getOauthBodyWithRefreshTokenGrantType(state), body),
            actions: {
                onSuccess: [
                    setAccessToken,
                    setRefreshToken,
                    setIsPending(false)
                ],
                onError: [
                    setIsPending(false)
                ]
            },
            beforeLogout
        }));
    });
